/*
* @TagDialog.vue.vue
* @Description
* @Author jsh
* @Date 2021/6/28
*/
/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >
        <el-form class="head-image-form" label-width="130px" :model="videoForm" :rules="rules" ref="videoForm" >

            <!-- 不可编辑 -->
            <el-form-item class="row-items-2" label="摄像头厂家：" prop="brand">
                <el-select v-model="videoForm.brand" placeholder="请选择摄像头厂家" @change="searchNVR()" :disabled="dialogForm.isEdit">
                    <el-option v-for="(item,index) in brands" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <!-- 不可编辑 -->
            <el-form-item class="row-items-2" label="读取类型：" prop="readMode">
                <el-select v-model="videoForm.readMode" placeholder="请选择读取类型" @change="searchNVR()" :disabled="dialogForm.isEdit">
                    <el-option v-for="(item,index) in readModes" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                </el-select>
            </el-form-item>

            <!-- 不可编辑, 选择硬盘录像机 -->
            <el-form-item class="row-items-2" label="IP：" prop="ip" v-if="videoForm.readMode == 1">
              <el-select v-model="videoForm.ip" placeholder="请选择硬盘录像机IP" filterable clearable @change="changeIp">
                <el-option v-for="(item, key) in nvrs" :key="item.diskIp" :label="item.diskIp" :value="item.diskIp" ></el-option>
              </el-select>
            </el-form-item>

            <!-- 选择硬盘录像机，不可编辑 -->
            <el-form-item class="row-items-2" label="账号：" prop="account">
                <el-input v-model="videoForm.account" autocomplete="off" clearable :disabled="videoForm.readMode==1" />
            </el-form-item>

            <!-- 选择硬盘录像机，不可编辑 -->
            <el-form-item class="row-items-2" label="密码：" prop="password" @blur.native.capture="searchNVR" >
                <el-input type="password" v-model="videoForm.password" autocomplete="new-password" clearable @keyup.enter.native="searchNVR" :disabled="videoForm.readMode==1" />
            </el-form-item>

            <!-- 添加时，选择硬盘录像机，支持摄像头通道多选 -->
            <el-form-item class="row-items-2" label="通道号：" prop="diskChannelNos" v-if="!dialogForm.isEdit && videoForm.readMode == 1">
              <el-select v-model="videoForm.diskChannelNos" multiple  placeholder="可以多选" filterable>
                <el-option v-for="(item,index) in videoForm.channelNos" :key="item.id" :label="item.id" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>

            <!-- 编辑时，显示单通道，不可编辑作为查看 -->
            <el-form-item class="row-items-2" label="通道号：" prop="diskChannelNo" v-if="dialogForm.isEdit && videoForm.readMode == 1">
              <el-input v-model="videoForm.diskChannelNo" autocomplete="off" clearable  :disabled="dialogForm.isEdit && videoForm.readMode == 1"/>
            </el-form-item>

            <!-- 选择摄像头时，不可编辑作为查看 -->
            <el-form-item class="row-items-2" label="摄像头IP：" prop="cIp" v-if="videoForm.readMode == 2">
                <el-input v-model="videoForm.cIp" clearable :disabled="dialogForm.isEdit"/>
            </el-form-item>

            <!-- 选择摄像头时，不可编辑作为查看 -->
            <el-form-item class="row-items-2" label="视频编号：" prop="number" v-if="dialogForm.isEdit || videoForm.readMode == 2">
                <el-input v-model="videoForm.number" clearable placeholder="自定义" :disabled="videoForm.readMode==1"/>
            </el-form-item>

            <!-- 选择摄像头时，不可编辑作为查看 -->
            <el-form-item class="row-items-2" label="视频名称：" prop="diskChannelName" v-if="dialogForm.isEdit || videoForm.readMode == 2">
                <el-input v-model="videoForm.diskChannelName" clearable :disabled="videoForm.readMode==1"/>
            </el-form-item>

            <el-form-item class="row-items-2" label="码流类型：" prop="subtype" v-if="dialogForm.isEdit || videoForm.readMode == 2">
                <el-select v-model="videoForm.subtype" placeholder="请选择码流类型" :disabled="videoForm.readMode==1">
                    <el-option v-for="(item,index) in subtypes" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                </el-select>
            </el-form-item>

           <el-form-item class="row-items-2" label="编码格式：" prop="codec" v-if="dialogForm.isEdit || videoForm.readMode == 2">
                <el-select v-model="videoForm.codec" placeholder="请选择码流类型" :disabled="videoForm.readMode==1">
                    <el-option v-for="(item,index) in codecs" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                </el-select>
            </el-form-item>

           <el-form-item class="row-items-2" label="SIP服务地址：" prop="sipServerAddr" v-if="videoForm.readMode == 1" style="display: none;">
                <el-input v-model="videoForm.sipServerAddr" autocomplete="off" clearable />
            </el-form-item>

           <el-form-item class="row-items-2" label="SIP认证ID：" prop="sipAuthId" v-if="videoForm.readMode == 1" style="display: none;">
                <el-input v-model="videoForm.sipAuthId" autocomplete="off" clearable />
            </el-form-item>

           <el-form-item class="row-items-2" label="SIP通道ID：" prop="sipVideoId" v-if="videoForm.readMode == 1" style="display: none;">
                <el-input v-model="videoForm.sipVideoId" autocomplete="off" clearable />
            </el-form-item>

            <el-form-item class="row-items-2" label="关联地图：">
              <el-select v-model="videoForm.mapId" clearable>
                <el-option v-for="(item,key) in maps" :key="item.mapId" :label="item.mapName" :value="item.mapId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="row-items-2" label="是否开启：" v-if="!dialogForm.isEdit">
              <el-switch
                  size="mini"
                  class="switchStyle"
                  v-model="videoForm.isOpen"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#00A854"
                  active-text="启用"
                  inactive-color="gray"
                  inactive-text="禁用"
              >
              </el-switch>
            </el-form-item>

            <el-form-item class="row-items-2" label="位置坐标：" v-if="dialogForm.isEdit && videoForm.pointX != null && videoForm.pointY != null">
              {{'X：' + videoForm.pointX + '， Y：' + videoForm.pointY}}
            </el-form-item>

            <el-form-item  class="row-items-1 btn-form-item-r">
                <el-button type="primary" size="primary" @click.native="submit">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

/* JS */
<script>

    // 基站信息 组件
    import ApiVideo from '@/request/api-video'
    import ApiOam from '@/request/api-oam'
    // 下拉树结构 组件
    // import TreeSelect from '@/components/TreeSingleSelect.vue'
    import {checkEmpty, checkFormat, validFormat} from "@/global/global-valid";

    export default {
        /**
         * @Des 组件名
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        name: "VideoDialog",
        /**
         * @Des 数据定接收类型
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        props: {
            // areas: Array,
            brands: Array,
            readModes: Array,
            subtypes: Array,
            codecs: Array,
            maps: Object
        },
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 2021/7/1
         */
        components: {
            // 选择树
            // TreeSelect
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 08:46 2021/6/29
         */
        data() {
          return {
              // 弹出层属性
              dialogForm: {
                  title: "",
                  isEdit: false,
                  areaShow: false,
                  dialogFormVisible: false,
                  submitButton: ''
              },
              /**
               * @Des 标签属性
               * @Auth jsh
               * @Date 14:39 2021/6/28
               */
              videoForm: {
                  index: -1,
                  // 视频id
                  cameraId: '',
                  // 视频编号
                  number: '',
                  // 读取方式
                  readMode: '',
                  // 品牌
                  brand: '',
                  // IP
                  ip: '',
                  // 账号
                  account: '',
                  // 密码
                  password: '',
                  // 码流类型
                  subtype: 1,
                  // 编码格式
                  codec: 1,
                  // 地图ids
                  mapId: '',
                  // 开启
                  isOpen: 1,
                  // 通道号
                  diskChannelNo: '',
                  // 通道号
                  diskChannelNos: [],
                  // 通道名
                  diskChannelName: '',
                  // 64通道
                  channelNos: [],
                  videos: {},
                  cIp: '',
                  sipServerAddr: '',
                  sipAuthId: '',
                  sipVideoId: '',
                  pointX: null,
                  pointY: null,
                  pointZ: null
              },
              nvrs:[],
              /**
               * @Des 规则属性
               * @Auth jsh
               * @Date 14:39 2021/6/28
               */
              rules: {
                  number: [
                      { required: true, message: '请输入视频编号', trigger: 'blur' },
                  ],
                  diskChannelNo: [{
                      validator: (rule, value, callback) => {
                          if (this.videoForm.readMode == 1 && checkEmpty(value)) {
                              new callback(new Error("请选择通道号"));
                          } else {
                              callback()
                          }
                      },
                      trigger: "blur"
                  }],
                  diskChannelName: [
                      { required: true, message: '请输入视频名称', trigger: 'blur' },
                  ],
                  account: [
                      { required: true, message: '请输入账号', trigger: 'blur' },
                  ],
                  password: [
                      { required: true, message: '请输入密码', trigger: 'blur' },
                  ],
                  ip: [
                      { required: true, message: '请输入IP', trigger: 'blur' },
                      {
                          validator: (rule, value, callback) => {
                              if (!checkEmpty(value) && !checkFormat(value, validFormat.ip)) {
                                  new callback(new Error("IP格式错误"));
                              } else {
                                  callback()
                              }
                          },
                          trigger: "blur"
                      }
                  ],
                  readMode: [
                      { required: true, message: '请选择读取方式', trigger: 'blur' },
                  ],
                  brand: [
                      { required: true, message: '请选择品牌', trigger: 'blur' },
                  ],
                  subtype: [
                      { required: true, message: '请选择码流类型', trigger: 'blur' },
                  ],
                  codec: [
                      { required: true, message: '请选择编码格式', trigger: 'blur' },
                  ],
              }
          }
        },
        mounted() {
          this.findNVR();
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        methods: {
            /**
             * @Des 打开弹出层
             * @Auth jsh
             * @Date 09:46 2021/6/28
             */
            openDialog(isEdit, title, data, index) {
                this.dialogForm.title = title;
                this.dialogForm.isEdit = isEdit;
                this.dialogForm.dialogFormVisible = true;
                this.dialogForm.submitButton = "保存视频配置";
                // 添加-清空数据
                if (!isEdit) {
                    this.videoForm.index = -1;
                    this.videoForm.brand = this.brands[0].id;
                    this.videoForm.readMode = this.readModes[0].id;
                    this.videoForm.subtype = this.subtypes[0].id;
                    this.videoForm.codec = this.codecs[0].id;
                    this.videoForm.mapId = '';
                }

                  // 编辑-填充数据
                if (isEdit && data) {
                    this.videoForm.index = index
                    this.videoForm.cameraId = data.cameraId;
                    this.videoForm.number = data.number;
                    this.videoForm.areaId = data.areaId;
                    this.videoForm.mapId = data.mapId==0?"":data.mapId;
                    this.videoForm.mapName = data.mapName;
                    this.videoForm.readMode = data.readMode;
                    this.videoForm.brand = data.brand;
                    this.videoForm.ip = data.readMode == 1 ? data.diskIp : data.cameraIp;
                    this.videoForm.account = data.readMode == 1 ? data.diskAccount : data.cameraAccount;
                    this.videoForm.password = data.readMode == 1 ? data.diskPassword : data.cameraPassword;
                    this.videoForm.diskChannelName = data.diskChannelName;
                    this.videoForm.subtype = data.subtype;
                    this.videoForm.codec = data.codec;
                    this.videoForm.isOpen = data.isOpen;
                    this.videoForm.diskChannelNo = data.diskChannelNo;
                    this.videoForm.cIp = data.cameraIp;
                    this.videoForm.sipServerAddr = data.sipServerAddr;
                    this.videoForm.sipAuthId = data.sipAuthId;
                    this.videoForm.sipVideoId = data.sipVideoId;
                    this.videoForm.pointX = data.pointX;
                    this.videoForm.pointY = data.pointY;
                    this.videoForm.pointZ = data.pointZ;
                  }
            },
            /**
             * 查询NVR数据
             * */
            findNVR(){
                this.$request.postJsonRequest(ApiOam.Search_NVR_Uri, {
                }).then(result => {
                  // console.log(result);
                  this.nvrs = Object.assign({}, {});
                  if(result.total > 0){
                    result.rows.forEach((row, index) => {
                      this.nvrs[row.diskIp] = row;
                    });
                  }
                }).catch(error => {
                    console.error('NVR查询异常', ApiOam.Get_NVR_Uri, error);
                })
            },
            /**
             * 查询NVR数据
             * */
            searchNVR(){
                // console.log(this.videoForm.brand, this.videoForm.readMode, this.videoForm.ip, this.videoForm.account, this.videoForm.password)
                this.videoForm.channelNos = Object.assign([], []);
                this.videos = Object.assign({}, {});
                if(this.videoForm.brand == 1
                    && this.videoForm.readMode == 1
                    && this.videoForm.ip != ''
                    && this.videoForm.account != ''
                    && this.videoForm.password != ''
                ){
                    this.$request.postJsonRequest(ApiOam.Get_NVR_Uri, {
                        brand: this.videoForm.brand,
                        ip: this.videoForm.ip,
                        user: this.videoForm.account,
                        pass: this.videoForm.password,
                        timeOut: 2000,
                    }).then(result => {
                        if (result.code == 0) {
                            if(!this.$checkEmpty(result.data)){
                                for(let i=0;i<result.data.length;i++){
                                    this.videoForm.channelNos.push({
                                        id: result.data[i].cNo,
                                        name: result.data[i].cName,
                                        subtype: result.data[i].bst,
                                        cIp: result.data[i].cameraIp,
                                        codec: result.data[i].codeP,
                                        number: result.data[i].cameraIp.replaceAll(".", ""),
                                    });
                                    this.videos[result.data[i].cNo] = result.data[i];
                                }
                                this.changeCNo();
                                return ;
                            }
                        } else {
                            console.log(result)
                        }
                    }).catch(error => {
                        console.error('NVR查询异常', ApiOam.Get_NVR_Uri, error);
                    })
                }
            },
            changeIp(ip){
              this.videoForm.account = '';
              this.videoForm.password = '';
              if(ip != ''){
                this.videoForm.account = this.nvrs[ip].user;
                this.videoForm.password = this.nvrs[ip].pass;
                this.videoForm.sipServerAddr = this.nvrs[ip].sipServerAddr
                this.videoForm.sipAuthId = this.nvrs[ip].sipAuthId
                this.videoForm.sipVideoId = this.nvrs[ip].sipVideoId
              }
              this.searchNVR();
            },
            /**
             * 改变通道号
             * */
            changeCNo(){
                this.videoForm.channelNos.forEach((row, i) => {
                    if(row.id == this.videoForm.diskChannelNo){
                        if(row.name){
                            this.videoForm.diskChannelName = row.name;
                        }
                        if(row.subtype){
                            this.videoForm.subtype = row.subtype;
                        }
                        if(row.codec){
                            this.videoForm.codec = row.codec;
                        }
                        if(row.number){
                            this.videoForm.number = row.number;
                        }
                        if(row.cIp){
                            this.videoForm.cIp = row.cIp;
                        }
                    }
                });
            },
            /**
             * 改变通道号
             * */
            selectCNo(){
              // console.log(this.videoForm.diskChannelNos)
            },
            /**
             * @Des 提交数据
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            submit(){
                this.$refs.videoForm.validate(valid => {
                    if(!valid) return false;
                    let videos = [];
                    for(let i = 0;i<this.videoForm.diskChannelNos.length;i++){
                        videos[i] = this.videos[this.videoForm.diskChannelNos[i]];
                    }
                    let param = {
                        index: this.videoForm.index,
                        cameraId: this.videoForm.cameraId,
                        number: this.videoForm.number,
                        mapId: this.videoForm.mapId,
                        readMode: this.videoForm.readMode,
                        brand: this.videoForm.brand,
                        diskIp: this.videoForm.readMode==1?this.videoForm.ip: '',
                        diskAccount: this.videoForm.readMode==1?this.videoForm.account:'',
                        diskPassword: this.videoForm.readMode==1?this.videoForm.password:'',
                        diskChannelNo: this.videoForm.diskChannelNo,
                        diskChannelName: this.videoForm.diskChannelName,
                        cameraIp: this.videoForm.cIp,
                        cameraAccount: this.videoForm.account,
                        cameraPassword: this.videoForm.password,
                        subtype: this.videoForm.subtype,
                        codec: this.videoForm.codec,
                        isOpen: this.videoForm.isOpen,
                        projectId: this.$store.state.currentProjectId,
                        sipServerAddr: this.videoForm.sipServerAddr,
                        sipAuthId: this.videoForm.sipAuthId,
                        sipVideoId: this.videoForm.sipVideoId,
                        videos: videos,
                    }
                    let api = this.dialogForm.isEdit ? ApiVideo.updateVideoConfigApi : ApiVideo.addVideoApi;
                    this.$request.postJsonRequest(api, param).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '摄像头保存成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });

                            this.dialogForm.dialogFormVisible = false;

                            // 添加成功
                            this.$emit("reSearch", param);
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error(this.dialogForm.isEdit?'摄像头编辑异常':'摄像头添加异常', api, error);
                    })
                })
            },
            /**
             * @Des 弹窗关闭
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            handleDialogClose() {
                this.reset();
            },
            /**
             * @Des 重置
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            reset() {
                this.cleanValidate('videoForm');
                this.cleanData();
            },

            /**
             * @Des 清除表单验证
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanValidate(formName) {
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清除数据
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanData() {
                this.videoForm.index = -1;
                this.videoForm.cameraId = '';
                this.videoForm.number = '';
                this.videoForm.mapId = '';
                this.videoForm.isOpen = 1;
            }
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
    /deep/ .el-dialog {
        width: 1200px;
        max-width: 90%;
    }
    /deep/ .el-dialog__body {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/VideoDialog.vue